import React from 'react';
import GaugeChart from 'react-gauge-chart';

import * as models from '../../../utils/models';

const Guage: React.FC<models.GuageProps> = (props) => {
	return (
		<GaugeChart
			id={React.useId()}
			colors={props.colors}
			percent={props.percent}
			textColor={props.textColor}
			nrOfLevels={props.nrOfLevels}
			arcsLength={props.arcsLength}
			arcWidth={0.1}
			arcPadding={0.03}
			cornerRadius={3}
			style={{ height: '50%', width: '100%' }}
		/>
	);
};

export default Guage;
